export const GANTT_SELECTED_LABOURER = "GANTT_SELECTED_LABOURER";
export const CHANGE_GANTT_WIDTH = "CHANGE_GANTT_WIDTH";

export const setSelectedLabourer = (selectedLabourer) => {
    return {
        type: GANTT_SELECTED_LABOURER,
        selectedLabourer,
    };
};

export const changeGanttWidth = (width) => {
    return {
        type: CHANGE_GANTT_WIDTH,
        width,
    };
};
